const template = require('./addAssets.html');
require('./addAssets.scss');
require('ng-file-upload');
var logger = require('../../common/logging.config');

// ng-file-upload $error tokens
const $ERROR_PATTERN = "pattern";
const $ERROR_MAX_SIZE = "maxSize";
const $ERROR_MAX_FILES = "maxFiles";


class AddAssetsController {

	constructor($scope, $state, assetUploadService, tenantRegistryService, shellUtil) {
		this.hasError = false;
		this.errorMessages = [];
		this.tenantRegistryService = tenantRegistryService;
		this.shellUtil = shellUtil;

		this.state = $state;
		this.assetUploadService = assetUploadService;

		// upload icon used for tablet view button
		this.img = require('../../common/icons/Upload-20px.svg');

		// Examine the userAgent to tell if we are on a mobile device (no drop zone for that case)
		const isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
		$scope.isDesktop = !isMobile;
		
		// Default File restrictions
		this.acceptType = assetUploadService.getFileAcceptType();             // Set accepted or excluded files
		this.maxSize = assetUploadService.getDefaultFileMaxSize();            // Default max size of one file
		//this.getTenantInformation();    // content team no longer wants widget to perform this check
		this.maxFiles = assetUploadService.getMaxFilesPerUpload();            // Max number of files that can be dropped into the widget
		this.maxUploadInstances = assetUploadService.getMaxUploadInstances(); // Max number of asset upload instances that can be active at once
	}

	// get the true max size of a file for this tenant
	getTenantInformation() {
		this.assetUploadService.getFileMaxSize().then(
			(data) => {
				this.maxSize = data;
				logger.info("addAssets setting max upload size: " + this.maxSize);
			},
			(error) => {
				logger.error('addAssets: Error retrieving tenant max file size information from server: ' + error);
			}
		);
	}
	
	fileUpload(validFiles, invalidFiles) {
		logger.info("AddAssetsController fileUpload entry");
		this.shellUtil.bindAnalytics("e", "WCH Widget Upload Asset", "WCH Widgets");
		
		this.hasError = false;
        this.errorMessages = [];

        // Get the number of valid and invalid files reported by the angular upload code
        var numOfValidFiles = 0;
        var numOfInvalidFiles = 0;
        
		if (validFiles && validFiles.length >= 1) {
			logger.info("Valid files found, number of files = " + validFiles.length);
			numOfValidFiles = validFiles.length;
		}
		
		if (invalidFiles && invalidFiles.length >= 1) {
			logger.info("Invalid files found, number of files = " + invalidFiles.length);
			numOfInvalidFiles = invalidFiles.length;
		}
        
		// check for invalid files first
		var maxFilesError = false;
		if (numOfInvalidFiles >= 1) {
			this.hasError = true;
			
			// Only show one error for selecting more than max number of files to upload at once
			invalidFiles.forEach(file => {
				if (file.$error === "maxFiles") {
					if (!maxFilesError) {
						// only push one error message for too many files
						maxFilesError = true;
						this.errorMessages.push(this.getErrorMessage(file));
					}
				}
				// let all the other error message types through
				else {
					this.errorMessages.push(this.getErrorMessage(file));
				}
			});
			
			// finally check to see if the number of invalid + valid files exceeds the max
			// this is necessary as the upload code in some situations does not report the user 
			// selected too many files (11 files were selected, 2 of them were too big - only reports
			// the error that 2 files were too large)
			if (!maxFilesError && (numOfValidFiles + numOfInvalidFiles > this.maxFiles)) {
		    	var errorMessage = {};
            	errorMessage.key = "invalidNumberOfFiles";
        		errorMessage.fileName = ""; 
				this.errorMessages.push(errorMessage);
			}
		}
		// nothing invalid so far, so handle valid files
		else if (numOfValidFiles >= 1) {
			// sanity check - don't think the ng file upload code will ever do this
			// seems to always report 1 file as invalid once we exceed max but just in case
			if (numOfValidFiles > this.maxFiles) {
		    	var errorMessage2 = {};
            	errorMessage2.key = "invalidNumberOfFiles";
        		errorMessage2.fileName = ""; 
				this.errorMessages.push(errorMessage2);
			}
			else {
				// perform last check
				this.verifyUpload(validFiles);
				
				if (!this.hasError) {
		            var fileListId = this.assetUploadService.addFileList(validFiles);
		            if (fileListId !== null) {
		    			logger.info("fileListId = " + fileListId);
		                this.state.go('authoring.assets.wizard', {"fileListId": fileListId});
		            } else {
		                logger.error("AddAssetsController.fileUpload: File list id was not created from files ", validFiles);
		            }
				}
			}
		}
	}

	// the angular file upload code can't validate certain things, so final checks here
	verifyUpload(validFiles) {
        // Don't allow files without a file extension (not caught from ng-file-upload)
        validFiles.forEach(file => {
            const index = file.name.indexOf(".");
            if ((index === -1) || (index >= file.name.length - 1)) {
            	var errorMessage = {};
				errorMessage.key = "invalidFileType";
				errorMessage.fileName = file.name; 
			    this.errorMessages.push(errorMessage);
				this.hasError = true;
                logger.info("AddAssetsController.verifyUpload: Invalid file without an extension detected: ", file.name);
            }
        });
        
        // Check for max number of bulk upload instances reached
        const numberOfFileLists = this.assetUploadService.getNumberOfFileLists();
        if (numberOfFileLists >= this.maxUploadInstances) {
        	var errorMessageUpload = {};
        	errorMessageUpload.key = "You can not upload more assets since there are too many existing asset uploads in process. Please wait until the uploads have finished or cancel them.";
		    this.errorMessages.push(errorMessageUpload);
			this.hasError = true;
            logger.info("AddAssetsController.verifyUpload: Too many file uploads currently in process.");
        }
	}
	

	// Examine the file error recorded by ng file upload and return a corresponding error message key
    getErrorMessage(file) {
    	var errorMessage = {};
		switch (file.$error) {
			case $ERROR_PATTERN: 
				errorMessage.key = "invalidFileType";
				break;
			case $ERROR_MAX_SIZE: 
				errorMessage.key = "invalidFileSize";
				break;
            case $ERROR_MAX_FILES: 
            	errorMessage.key = "invalidNumberOfFiles";
            	break;
			default: 
				errorMessage.key = "invalidFileDefault";
		}
		// set the filename even though it may not be needed for this particular error message
		errorMessage.fileName = file.name; 
		return errorMessage;
	}

    // remove the error message specified by the index
    clearErrorMessage(index) {
    	if (this.errorMessages && index < this.errorMessages.length) {
    		this.errorMessages.splice(index, 1);
    	}
    }
	
};

module.exports = {
	templateUrl: template,
	controller: ["$scope", "$state", "assetUploadService", "tenantRegistryService", "shellUtil", AddAssetsController]
};



// WEBPACK FOOTER //
// ./app/components/addAssets/addAssets.component.js